import React from "react";
import {PanelTab} from "../panel-tab/PanelTab";
import {ICustomTabWindow} from "../interfaces/ICustomTabWindow";
import {JobStepRunLog} from "./JobStepRunLog";
import {JobStepRunGeneral} from "./JobStepRunGeneral";
import {JobStepRunDetails} from "./JobStepRunDetails";

interface IJobStepRunProps {
	jobRunId: number;
	jobStepRunId: number;
}

export const JobStepRun: React.FC<IJobStepRunProps> = (props) => {
	const tabs: ICustomTabWindow[] = [
		{
			title: "General",
			window: (<JobStepRunGeneral {...props} /> ),
		},
		{
			title: "Logs",
			window: (<JobStepRunLog {...props} /> ),
		},
		{
			title: "Details",
			window: (<JobStepRunDetails {...props} /> ),
		}
	];
	
	return (
		<>
			<PanelTab tabs={tabs}  />
		</>
	);
};
